import script from "./LiveSportsFixtureBook.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveSportsFixtureBook.vue?vue&type=script&setup=true&lang=js"

import "./LiveSportsFixtureBook.vue?vue&type=style&index=0&id=adc19246&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adc19246"]])

export default __exports__